import React from "react";

import { myGlobals, myUtilities } from "../../Utils";
import TrifectaCover from "./TrifectaCover";
import * as DOMPurify from 'dompurify';
class ErrorComponent extends React.Component {
    onClick = () => {
      window.location = myGlobals.initialLink;
    };
    showBackButton = () => {
      if (this.props.isTopBuild) {
        return (
          <button className="error-back-button" onClick={this.onClick}>
            {myUtilities.accountSpecificLanguage('Error.Button.GoBack', 'Go Back')}
          </button>
        );
      }
    };
    renderErrorComp = () => {
        return (
          <div className="centered-container">
            {myUtilities.accountSpecificLanguage('Error.Message.ErrOccured', 'Error Occurred')}: {this.props.errorMessage}
            <br />
            {this.showBackButton()}
          </div>
        );
      };
      render() {
    	    return myGlobals.currentTheme === "trifectaTheme.css" ? (
    	      <TrifectaCover> {this.renderErrorComp()} </TrifectaCover>
    	    ) : (
    	      this.renderErrorComp()
    	    );
    }
  }
  export default ErrorComponent;